import React from 'react';

import { asDraggableContentListItem, useSortableListItem } from '../../../_lib/components/SortableContentList';
import { CalendarEditableElement } from '../CalendarTypes';
import { StatusInfoError } from '../../../_lib/components/StatusInfo';
import { ContainerWithCommonContextMenu } from '../../../_lib/components/ContextMenu';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { SonForm } from '../../../_lib/Form2';
import { ContextMenuButtonProps } from '../../../_lib/components/ContextMenu/partials/ContextMenuButton';
import { StatusInfoModifier } from '../../../_lib/components/StatusInfo/partials/StatusInfo';

type CalendarListItemProps = CalendarEditableElement & {
  openDeleteForm: (form: SonForm<any>) => void;
};

function CalendarListItem({ id, calendarTitle, delete: deleteForm, openDeleteForm }: CalendarListItemProps) {
  const { t } = useSonTranslation('Calendar');
  const { move, nextItemId, prevItemId, error } = useSortableListItem(id);
  const contextMenuActions: ContextMenuButtonProps[] = [
    {
      children: t('removeCalendar'),
      key: t('removeCalendar'),
      name: 'removeForm',
      onClick: event => {
        event.preventDefault();
        event.stopPropagation();

        openDeleteForm(deleteForm);
      },
    },
    {
      children: t('moveUp'),
      key: 'moveElementUp',
      disabled: !prevItemId,
      onClick: event => {
        event.preventDefault();
        event.stopPropagation();
        if (prevItemId) {
          move(prevItemId);
        }
      },
    },
    {
      children: t('moveDown'),
      key: 'moveElementDown',
      disabled: !nextItemId,
      onClick: event => {
        event.preventDefault();
        event.stopPropagation();
        if (nextItemId) {
          move(nextItemId);
        }
      },
    },
  ];

  return (
    <>
      <ContainerWithCommonContextMenu
        toolTip={t('manageCalendar', { name: calendarTitle })}
        actions={contextMenuActions}
      >
        <p className="font-bold-15-21">{calendarTitle}</p>
      </ContainerWithCommonContextMenu>
      {error && <StatusInfoError message={t('errorResponse')} modifier={StatusInfoModifier.PADDING_TOP} />}
    </>
  );
}

export const DraggableCalendarListItem = asDraggableContentListItem(CalendarListItem);
